import { t } from "@/i18n-js/instance";
import socialProof from "./socialProof.svg";

const localeRoot = "pricing_plans.plan_settings.plan_selection";

interface SocialProofProps {
  scale?: number;
}

export const SocialProof = ({ scale = 1 }: SocialProofProps) => (
  <img
    src={socialProof}
    loading="lazy"
    alt={t([localeRoot, "title"])}
    style={{ transform: `scale(${scale})` }}
  />
);
